class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
   // facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {

    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    if(document.querySelector(".collection-products-count") && parsedHTML.querySelector("#ProductCount")){
      document.querySelector(".collection-products-count").innerHTML = parsedHTML.querySelector("#ProductCount").innerHTML.trim();
    }
 
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelectorAll(selector).forEach(item => item.innerHTML = html.querySelector(selector).innerHTML);
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer')?.bindEvents();
    document.getElementById('FacetFiltersFormMobile').closest('facet-filters-tab-drawer')?.bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {

    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {

    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());

            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function handleNavFilter($this, $event){
  const urlHref = $this.getAttribute("href");
 
     const url =
      urlHref.indexOf('?') == -1
        ? ''
        : urlHref.slice(urlHref.indexOf('?') + 1);
    $event.preventDefault();
     FacetFiltersForm?.renderPage(url);

 $this.closest('ul')?.querySelectorAll('a')?.forEach(a => a?.classList.remove(...['current-link','current-filter']));
  $this?.classList.add(...['current-link','current-filter']);


}


     const selectors$I = {
        popoutList: "[data-popout-list]",
        popoutToggle: "[data-popout-toggle]",
        popoutToggleText: "[data-popout-toggle-text]",
        popoutInput: "[data-popout-input]",
        popoutOptions: "[data-popout-option]",
        productGridImage: "[data-product-image]",
        productGridItem: "[data-grid-item]",
        section: "[data-section-type]",
    };

    const classes$y = {
        listVisible: "popout-list--visible",
        visible: "is-visible",
        active: "is-active",
        popoutListTop: "popout-list--top",
    };

    const attributes$s = {
        ariaExpanded: "aria-expanded",
        ariaCurrent: "aria-current",
        dataValue: "data-value",
       dataOptionName: "data-option-name",
        popoutToggleText: "data-popout-toggle-text",
        submit: "submit",
    };

class SortByPopout extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
          
            this.popoutList = this.querySelector(selectors$I.popoutList);
            this.popoutToggle = this.querySelector(selectors$I.popoutToggle);
            this.popoutToggleText = this.querySelector(
                selectors$I.popoutToggleText
            );
            this.popoutInput = this.querySelector(selectors$I.popoutInput);
            this.popoutOptions = this.querySelectorAll(
                selectors$I.popoutOptions
            );
            // this.productGridItem = this.popoutList.closest(
            //     selectors$I.productGridItem
            // );
            this.fireSubmitEvent = this.hasAttribute(attributes$s.submit);

            this.popupToggleFocusoutEvent = (evt) =>
                this.onPopupToggleFocusout(evt);
            this.popupListFocusoutEvent = (evt) =>
                this.onPopupListFocusout(evt);
            this.popupToggleClickEvent = (evt) => this.onPopupToggleClick(evt);
            this.keyUpEvent = (evt) => this.onKeyUp(evt);
            this.bodyClickEvent = (evt) => this.onBodyClick(evt);

            this._connectOptions();
            this._connectToggle();
            this._onFocusOut();
            this.popupListSetDimensions();
        }

        onPopupToggleClick(evt) {
            const button = evt.currentTarget;
            const ariaExpanded =
                button.getAttribute(attributes$s.ariaExpanded) === "true";

            // if (this.productGridItem) {
            //     const productGridItemImage = this.productGridItem.querySelector(
            //         selectors$I.productGridImage
            //     );

            //     if (productGridItemImage) {
            //         productGridItemImage.classList.toggle(
            //             classes$y.visible,
            //             !ariaExpanded
            //         );
            //     }

            //     this.popoutList.style.maxHeight = `${Math.abs(
            //         this.popoutToggle.getBoundingClientRect().bottom -
            //             this.productGridItem.getBoundingClientRect().bottom
            //     )}px`;
            // }

            evt.currentTarget.setAttribute(
                attributes$s.ariaExpanded,
                !ariaExpanded
            );
            this.popoutList.classList.toggle(classes$y.listVisible);
            this.popupListSetDimensions();
            this.toggleListPosition();

            document.body.addEventListener("click", this.bodyClickEvent);
        }

        onPopupToggleFocusout(evt) {
            const popoutLostFocus = this.contains(evt.relatedTarget);

            if (!popoutLostFocus) {
                this._hideList();
            }
        }

        onPopupListFocusout(evt) {
            const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
            const isVisible = this.popoutList.classList.contains(
                classes$y.listVisible
            );

            if (isVisible && !childInFocus) {
                this._hideList();
            }
        }

        toggleListPosition() {
            const button = this.querySelector(selectors$I.popoutToggle);
            const ariaExpanded =
                button.getAttribute(attributes$s.ariaExpanded) === "true";
            const windowHeight = window.innerHeight;
            const popoutTop = this.getBoundingClientRect().top;

            const removeTopClass = () => {
                this.popoutList.classList.remove(classes$y.popoutListTop);
                this.popoutList.removeEventListener(
                    "transitionend",
                    removeTopClass
                );
            };

            if (ariaExpanded) {
                if (windowHeight / 2 > popoutTop) {
                    this.popoutList.classList.add(classes$y.popoutListTop);
                }
            } else {
                this.popoutList.addEventListener(
                    "transitionend",
                    removeTopClass
                );
            }
        }

        popupListSetDimensions() {
            this.popoutList.style.setProperty("--max-width", "100vw");
            this.popoutList.style.setProperty("--max-height", "100vh");

            requestAnimationFrame(() => {
                this.popoutList.style.setProperty(
                    "--max-width",
                    `${parseInt(
                        document.body.clientWidth -
                            this.popoutList.getBoundingClientRect().left
                    )}px`
                );
                this.popoutList.style.setProperty(
                    "--max-height",
                    `${parseInt(
                        window.innerHeight -
                            this.popoutList.getBoundingClientRect().top
                    )}px`
                );
            });
        }

        popupOptionsClick(evt) {
            const link = evt.target.closest(selectors$I.popoutOptions);
            if (link.attributes.href.value === "#") {
                evt.preventDefault();

                const attrValue = evt.currentTarget.hasAttribute(
                    attributes$s.dataValue
                )
                    ? evt.currentTarget.getAttribute(attributes$s.dataValue)
                    : "";

               const attrOptionName = evt.currentTarget.hasAttribute(
                    attributes$s.dataOptionName
                )
                    ? evt.currentTarget.getAttribute(attributes$s.dataOptionName)
                    : "";

                this.popoutInput.value = attrValue;

                if (this.popoutInput.disabled) {
                    this.popoutInput.removeAttribute("disabled");
                }

                if (this.fireSubmitEvent) {
                    this._submitForm(attrValue);
                } else {
                    const currentTarget = evt.currentTarget.parentElement;
                    const listTargetElement = this.popoutList.querySelector(
                        `.${classes$y.active}`
                    );
                    const targetAttribute = this.popoutList.querySelector(
                        `[${attributes$s.ariaCurrent}]`
                    );

                     evt.currentTarget.closest('facet-filters-form').querySelector('form').dispatchEvent(new Event("input"));
                   // this.popoutInput.dispatchEvent(new Event("change"));
                 // this.popoutInput.dispatchEvent(new Event("input"));

                    if (listTargetElement) {
                        listTargetElement.classList.remove(classes$y.active);
                        currentTarget.classList.add(classes$y.active);
                    }


                    if (
                        targetAttribute &&
                        targetAttribute.hasAttribute(
                            `${attributes$s.ariaCurrent}`
                        )
                    ) {
                        targetAttribute.removeAttribute(
                            `${attributes$s.ariaCurrent}`
                        );
                        evt.currentTarget.setAttribute(
                            `${attributes$s.ariaCurrent}`,
                            "true"
                        );
                    }

                    if (attrOptionName !== "") {
                        this.popoutToggleText.innerHTML = attrOptionName;

                        if (
                            this.popoutToggleText.hasAttribute(
                                attributes$s.popoutToggleText
                            ) &&
                            this.popoutToggleText.getAttribute(
                                attributes$s.popoutToggleText
                            ) !== ""
                        ) {
                            this.popoutToggleText.setAttribute(
                                attributes$s.popoutToggleText,
                                attrOptionName
                            );
                        }
                    }
                    this.onPopupToggleFocusout(evt);
                    this.onPopupListFocusout(evt);
                }
            }
        }

        onKeyUp(evt) {
            if (evt.code !== "Escape") {
                return;
            }
            this._hideList();
            this.popoutToggle.focus();
        }

        onBodyClick(evt) {
            const isOption = this.contains(evt.target);
            const isVisible = this.popoutList.classList.contains(
                classes$y.listVisible
            );

            if (isVisible && !isOption) {
                this._hideList();
            }
        }

        _connectToggle() {
            this.popoutToggle.addEventListener(
                "click",
                this.popupToggleClickEvent
            );
        }

        _connectOptions() {
            if (this.popoutOptions.length) {
                this.popoutOptions.forEach((element) => {
                    element.addEventListener("click", (evt) =>
                        this.popupOptionsClick(evt)
                    );
                });
            }
        }

        _onFocusOut() {
            this.addEventListener("keyup", this.keyUpEvent);
            this.popoutToggle.addEventListener(
                "focusout",
                this.popupToggleFocusoutEvent
            );
            this.popoutList.addEventListener(
                "focusout",
                this.popupListFocusoutEvent
            );
        }

        _submitForm() {
            const form = this.closest("form");
            if (form) {
                form.submit();
            }
        }

        _hideList() {
            this.popoutList.classList.remove(classes$y.listVisible);
            this.popoutToggle.setAttribute(attributes$s.ariaExpanded, false);
            this.toggleListPosition();
            document.body.removeEventListener("click", this.bodyClickEvent);
        }
    }
customElements.define('sortby-popout', SortByPopout);

